export const AMBIANCES = ["Plage & mer", "Montagne & nature", "Culture & musées", "Gastronomie locale", "Vie nocturne", "Randonnée", "Sports", "Shopping", "Bien-être & spa", "Aventure", "Photographie", "Rencontres locales"];
export const HEBERGEMENTS = ["Hôtel 3★", "Hôtel 4-5★", "Airbnb", "Hostel", "Resort tout compris", "Éco-lodge", "Peu importe"];
export const RYTHMES = ["Très posé", "Équilibré", "Actif", "Intense"];
export const GASTRO = ["Cuisine locale", "Gastronomique", "Street food", "Végétarien", "Sans gluten", "Halal", "Peu importe"];
export const TRANSPORTS = ["Voiture de location", "Transports en commun", "Taxi", "Moto", "Vélo", "Vols intérieurs", "Peu importe"];
export const INTERETS = ["Histoire & archéologie", "Art & architecture", "Faune & flore", "Plongée", "Surf", "Yoga & méditation", "Vignobles", "Festivals", "Parcs nationaux"];
export const CONTRAINTES = ["Mobilité réduite", "Allergie alimentaire", "Peur de l'avion", "Femme enceinte", "Aucune contrainte"];
export const CONFORTS = ["Économique", "Confortable", "Premium", "Luxe"];
export const EXPERIENCES = ["Novice", "Intermédiaire", "Expérimenté", "Grand voyageur"];
export const DOCUMENTS_OPTIONS = ["Passeport valide", "Passeport + visa", "Passeport à renouveler", "Aucun document"];
export const TYPES_VOYAGE = ["Vacances classiques", "Lune de miel", "Famille", "Entre amis", "Solo", "Aventure", "City trip", "Bien-être"];

export const BUDGET_CATEGORIES = [
  { key: "repartition_hebergement",  label: "Hébergement",    color: "#C17F59" },
  { key: "repartition_restauration", label: "Restauration",   color: "#8B5E34" },
  { key: "repartition_activites",    label: "Activités",      color: "#5C8A5E" },
  { key: "repartition_transport",    label: "Transport local", color: "#5C6E8A" },
];

export const INITIAL = {
  ville_depart: "", destination: "", date_depart: "", date_retour: "",
  nb_adultes: 1, nb_enfants: 0,
  budget: "", budget_montant: "", budget_type: "total", vols_inclus: false,
  repartition_hebergement: 40, repartition_restauration: 25, repartition_activites: 25, repartition_transport: 10,
  type_voyage: "Vacances classiques",
  ambiances: [], hebergement: [], rythme: "Équilibré", gastronomie: [], transport_sur_place: [],
  centres_interet: [], contraintes_medicales: [], confort: "Confortable",
  experience_voyage: "Intermédiaire", texte_libre: "", documents_voyage: "Passeport valide",
};

export function toggle(arr, val) {
  return arr.includes(val) ? arr.filter((x) => x !== val) : [...arr, val];
}
